export default {
    state: {
        total: 500,
        boards: []
    }
};